/* globals femcare */

femcare.product.panel.info.default = {
    $mainPanel: $('.product-main').not('.product-main--shop'),
    mediaPanel: null,

    init: function () {
        if (this.$mainPanel.length) {
            this.mediaPanel = femcare.product.panel.media;
            this.mediaPanel.init();
        }
        this.initTooltips();
    },

    initTooltips: function () {
        var $flowMetrics = $('.product-metric--flow');

        if ($flowMetrics.length){
            $flowMetrics.each(function (index, element) {
                var $flowMetric = $(element);
                var flowContent = $flowMetric.find('.product-metric-tooltip')[0].outerHTML;
    
                $flowMetric.tooltip({
                    items: $flowMetric,
                    content: flowContent,
                    classes: {
                        'ui-tooltip': 'tooltip',
                        'ui-tooltip-content': 'tooltip__content'
                    }
                });
            });
        }
    },
}
